import React, { Component } from 'react'
import { Context } from '../../Context'
import logo from '../../../assets/rhomberg-logo.svg'
import Mouse from '../../../assets/mouse.png'
import AnimatedLogo from '../../Libs/AnimatedLogo'
import AnimatedBackgroundImage from '../../Libs/AnimatedBackgroundImage'
import { Link } from 'react-router-dom'

export default class Leistungen extends Component {
    static contextType = Context

    constructor(props) {
        super(props)

        this.state = {}
    }

    render() {
        return (
            <div className="main background-dark">
                <h1 className="page-title page-title-absolute text-white">Bauservice</h1>
                <AnimatedLogo image={logo} />
                <div className="row h-100">
                    <div className="col-12 col-md-6 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="pulse-no-animation">
                                                    <p>Leistungen</p>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <p>
                                                    <ul style={{ marginTop: 50 }} className="detail-list">
                                                        <li>Neubau</li>
                                                        <li>Zu- und Umbau</li>
                                                        <li>Althaussanierung</li>
                                                        <li>Durchbrüche</li>
                                                        <li>Gartenmauern</li>
                                                        <li>Schadensbehebungen</li>
                                                        <li>Verputze</li>
                                                    </ul>
                                                </p>
                                            </div>
                                        </div>
                                        <p className="text-red page-sub-desc">
                                            Als Bauunternehmen gestalten wir die Zukunft entscheidend mit. Das ist eine große Verantwortung, der wir uns stellen und die wir übernehmen – für diese und
                                            für die nachfolgenden Generationen. Für unsere Kunden sind wir über den gesamten Lebenszyklus der Gebäude ein kompetenter Partner.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-5 h-100">
                        <div className="row h-100 justify-content-center">
                            <div className="col-md-10 align-self-center">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <Link to="/bauservice/leistungen/verputzerteam">
                                            <div className="pulse-dark">
                                                <p>
                                                    <span className="undeline-overline">Neu:</span> <br />
                                                    <span>
                                                        Verputzer- <br />
                                                        arbeiten
                                                    </span>
                                                </p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 d-sm-none d-md-block h-100">
                        <AnimatedBackgroundImage class="animated-background-image" style={{ left: '300%' }} imageStyle={{ marginTop: '40%' }} image={Mouse} maxMoveX={400} maxMoveY={400} />
                    </div>
                </div>
            </div>
        )
    }
}
